import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import axios from "axios";
import useTable from "../components/useTable";
import ResponsiveDrawer from "../components/ResponsiveDrawer";
import ProgressBar from "../components/ProgressBar";
import SearchIcon from "@mui/icons-material/Search";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { makeStyles } from "@material-ui/core";
import { FaTimesCircle } from "react-icons/fa";
import { MdCheckCircle, MdError } from "react-icons/md";
import {
  Typography,
  Box,
  TextField,
  IconButton,
  Table,
  TableRow,
  TableCell,
  TableBody,
  Modal,
  LinearProgress,
  Button,
  Grid,
  Stack,
  InputAdornment,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/lab/";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import { Redirect } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "100vh",
    backgroundColor: "#F7F8FA",
  },
  tableHead: {
    fontWeight: "bold",
    fontSize: "12px",
    color: "#4D4F5C",
  },
  success: {
    fontSize: "14px",
    color: "#4CAF50",
  },
  fail: {
    fontSize: "14px",
    color: "#F44336",
  },
  attente: {
    fontSize: "14px",
    color: "#FF9800",
  },
  typo: {
    fontWeight: "bold !important",
    color: "red",
  },
  box: {
    display: "flex",
    flexDirection: "row",
  },
  icon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "51px",
    height: "51px",
  },
  toolbar: {
    height: "64px",
  },
  smallTableCell: {
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    alignItems: "center",
    paddingLeft: "10px",
  },
  tableBigScreen: {
    display: "block",
    [theme.breakpoints.down("sm")]: {
      display: "none!important",
    },
  },
  tableSmallScreen: {
    display: "block",
    [theme.breakpoints.up("sm")]: {
      display: "none!important",
    },
  },
}));

function Transactions(props) {
  const classes = useStyles();

  const [open, setOpen] = useState(false);
  const [openWait, setOpenWait] = useState(false);
  const [openSuccess, setOpenSuccess] = useState(false);
  const [openFailed, setOpenFailed] = useState(false);
  const [idTransac, setIdTransac] = useState();
  const [loading, setLoading] = useState(true);
  const [records, setRecords] = useState([]);
  const [monthlyDate, setMonthlyDate] = useState(null);
  const [showPass, setShowPass] = useState(false);
  const [password, setPassword] = useState("");
  const [failMessage, setFailMessage] = useState(
    "Nous avons rencontré une erreur, veuillez réessayer ou nous contacter."
  );

  let record = [];
  let monthlyRecord = [];
  let page = 1;
  let month = null;
  let year = null;
  let tokenStorage = null;
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  useEffect(() => {
    if (props.token) {
      tokenStorage = props.token;
    }
    if (isLoggedIn) {
      requestTransactions();
    }
  }, []);

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      sendApiCancel();
    }
  };

  const handleClickShowPassword = () => {
    setShowPass(!showPass);
  };

  const requestTransactions = async () => {
    // loading of transactions page per page to avoid waiting too long when there are too many transactions
    for (let i = 0; i < page; i++) {
      await axios
        .get(
          `https://bck-aix-en-provence.carloapp.com/api/business/merchant_transactions?page=${page}`,
          {
            method: "GET",
            headers: {
              Version: "4.0",
              Authorization: `Bearer ${tokenStorage}`,
            },
          }
        )
        .then((res) => {
          if (res.data.data.data.length > 0) {
            for (let i = 0; i < res.data.data.data.length; i++)
              record.push({
                id: res.data.data.data[i].id,
                customer_name: res.data.data.data[i].customer_name,
                created_at: res.data.data.data[i].created_at,
                payment_note: res.data.data.data[i].payment_note,
                amount: res.data.data.data[i].amount,
                cashback_used: res.data.data.data[i].cashback_used,
                cashback_earned: res.data.data.data[i].cashback_earned,
                canceled: res.data.data.data[i].canceled,
                settled: res.data.data.data[i].settled,
              });
            setRecords([]);
            setRecords([...record]);
            setLoading(false);
            page = page + 1;
          }
          return;
        });
    }
  };

  // API Call to get monthly transactions
  const monthlyTransactions = async (newDate) => {
    // console.log(">>newDate", newDate);
    // need to add 1900 because the method .getYear() in JS removes 1900 to the data
    year = newDate.getYear() + 1900;
    month = newDate.getMonth() + 1;
    await axios
      .get(
        `https://bck-aix-en-provence.carloapp.com/api/business/merchant_transactions?month=${month}&year=${year}`,
        {
          method: "GET",
          headers: {
            Version: "4.0",
            Authorization: `Bearer ${tokenStorage}`,
          },
        }
      )
      .then((res) => {
        // console.log(">>res", res.data.data.data);
        setMonthlyDate(newDate);
        monthlyRecord = [];
        for (let i = 0; i < res.data.data.data.length; i++) {
          monthlyRecord.push({
            id: res.data.data.data[i].id,
            customer_name: res.data.data.data[i].customer_name,
            created_at: res.data.data.data[i].created_at,
            payment_note: res.data.data.data[i].payment_note,
            amount: res.data.data.data[i].amount,
            cashback_used: res.data.data.data[i].cashback_used,
            cashback_earned: res.data.data.data[i].cashback_earned,
            canceled: res.data.data.data[i].canceled,
            settled: res.data.data.data[i].settled,
          });
        }
        setRecords(monthlyRecord);
        return;
      });
  };

  const headCells = [
    { id: "id", label: "ID" },
    { id: "client", label: "Client", disableSorting: true },
    { id: "date", label: "Date", disableSorting: true },
    { id: "payment_note", label: "Commentaire", disableSorting: true },
    { id: "montant", label: "Montant", disableSorting: true },
    { id: "Cashback utilisé", label: "Cashback utilisé", disableSorting: true },
    { id: "Cashback donné", label: "Cashback donné", disableSorting: true },
    {
      id: "Statut transaction",
      label: "Statut transaction",
      disableSorting: true,
    },
    { id: "Statut transfert", label: "Statut transfert", disableSorting: true },
    { id: " ", label: " ", disableSorting: true },
  ];

  const { TblPagination, TblHead, recordsAfterPagingAndSorting } = useTable(
    records,
    filterFn,
    headCells
  );

  const cancelTransac = (id) => {
    setIdTransac(id);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const sendApiCancel = async () => {
    setOpen(false);
    setOpenWait(true);
    const deleteTransac = await fetch(
      `https://bck-aix-en-provence.carloapp.com/api/business/cancel_transaction_v2`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Version: "4.0",
          Authorization: `Bearer ${tokenStorage}`,
        },
        body: `transaction_id=${idTransac}&password=${password}`,
      }
    );
    const body = await deleteTransac.json();
    // console.log(">>body", body);
    if (body.status === true) {
      setOpenWait(false);
      setOpenSuccess(true);
    } else {
      if (body.message === "the password is invalid") {
        setFailMessage("Le mot de passe est incorrect, veuillez réessayer.");
      }
      setOpenWait(false);
      setOpenFailed(true);
    }
  };

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        const query = target.value.toLowerCase();
        return items.filter(
          (x) =>
            x.customer_name.toLowerCase().includes(query) ||
            (x.payment_note || "").toLowerCase().includes(query)
        );
      },
    });
  };

  const listTransactions = recordsAfterPagingAndSorting().map(
    (transaction, i) => {
      return (
        <TableRow
          key={i}
          sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
          className={classes.hideTypo}
        >
          <TableCell>{transaction.id}</TableCell>
          <TableCell>{transaction.customer_name}</TableCell>
          <TableCell>{transaction.created_at}</TableCell>
          <TableCell>{transaction.payment_note || "-"}</TableCell>
          <TableCell sx={{ fontWeight: "bold" }}>
            {transaction.amount}€
          </TableCell>
          <TableCell>{transaction.cashback_used}€ </TableCell>
          <TableCell>{transaction.cashback_earned}€</TableCell>
          <TableCell>
            {transaction.canceled ? (
              <Typography className={classes.fail}>Annulée</Typography>
            ) : (
              <Typography className={classes.success}>Complétée</Typography>
            )}
          </TableCell>
          <TableCell>
            {transaction.settled ? (
              <Typography className={classes.success}>Transférée</Typography>
            ) : (
              <Typography className={classes.attente}>En attente</Typography>
            )}
          </TableCell>
          <TableCell>
            {transaction.canceled ? null : (
              <IconButton
                color="secondary"
                onClick={() => cancelTransac(transaction.id)}
              >
                <FaTimesCircle />
              </IconButton>
            )}
          </TableCell>
        </TableRow>
      );
    }
  );

  // listTransactions2 is a second table body but for small size screen
  const listTransactions2 = recordsAfterPagingAndSorting().map(
    (transaction, i) => {
      return (
        <TableRow
          key={i}
          sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
          className={classes.hideTypo}
        >
          <Grid className={classes.smallTableCell} item xs={12}>
            <Typography>ID</Typography>
            <TableCell>{transaction.id}</TableCell>
          </Grid>
          <Grid className={classes.smallTableCell} item xs={12}>
            <Typography>Client</Typography>
            <TableCell>{transaction.customer_name}</TableCell>
          </Grid>
          <Grid className={classes.smallTableCell} item xs={12}>
            <Typography>Date</Typography>
            <TableCell>{transaction.created_at}</TableCell>
          </Grid>
          <Grid className={classes.smallTableCell} item xs={12}>
            <Typography>Commentaire</Typography>
            <TableCell>{transaction.payment_note || "-"}</TableCell>
          </Grid>
          <Grid className={classes.smallTableCell} item xs={12}>
            <Typography>Montant</Typography>
            <TableCell sx={{ fontWeight: "bold" }}>
              {transaction.amount.toLocaleString("fr")}€
            </TableCell>
          </Grid>
          <Grid className={classes.smallTableCell} item xs={12}>
            <Typography>Cashback utilisé</Typography>
            <TableCell>
              {transaction.cashback_used.toLocaleString("fr")}€{" "}
            </TableCell>
          </Grid>
          <Grid className={classes.smallTableCell} item xs={12}>
            <Typography>Cashback donné</Typography>
            <TableCell>
              {transaction.cashback_earned.toLocaleString("fr")}€
            </TableCell>
          </Grid>
          <Grid className={classes.smallTableCell} item xs={12}>
            <Typography>Statut transaction</Typography>
            <TableCell>
              {transaction.canceled ? (
                <Typography className={classes.fail}>Annulée</Typography>
              ) : (
                <Typography className={classes.success}>Complétée</Typography>
              )}
            </TableCell>
          </Grid>
          <Grid className={classes.smallTableCell} item xs={12}>
            <Typography>Statut transfert</Typography>
            <TableCell>
              {transaction.settled ? (
                <Typography className={classes.success}>Transférée</Typography>
              ) : (
                <Typography className={classes.attente}>En attente</Typography>
              )}
            </TableCell>
          </Grid>
          <Grid className={classes.smallTableCell} item xs={12}>
            <TableCell>
              {transaction.canceled ? null : (
                <IconButton
                  color="secondary"
                  onClick={() => cancelTransac(transaction.id)}
                >
                  <FaTimesCircle />
                </IconButton>
              )}
            </TableCell>
          </Grid>
        </TableRow>
      );
    }
  );

  // Redirect user if not logged in
  let isLoggedIn = localStorage.getItem("token");
  if (isLoggedIn) {
    tokenStorage = isLoggedIn.slice(1, isLoggedIn.length - 1);
  }
  // console.log(">>local storage", isLoggedIn);
  if (!props.token && !isLoggedIn) {
    return <Redirect to="/" />;
  }
  if (!props.token && isLoggedIn) {
    props.onSetToken(tokenStorage);
  }

  return (
    <Box sx={{ display: "flex" }}>
      <ResponsiveDrawer />
      <Box className={classes.root} sx={{ flexGrow: 1, p: 3 }}>
        <div className={classes.toolbar}></div>

        {/* Start of component */}
        {/* ternary condition to show loading while waiting for api response */}
        {loading ? (
          <ProgressBar />
        ) : (
          <Box ml={2}>
            <h2>Transactions</h2>
            <Box sx={{ maxWidth: "95%", maxHeight: "100%" }}>
              <Box sx={{ display: "flex" }}>
                <TextField
                  label="Rechercher"
                  InputProps={{
                    endAdornment: (
                      <IconButton>
                        <SearchIcon />
                      </IconButton>
                    ),
                  }}
                  onChange={handleSearch}
                />
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <Stack ml={2}>
                    <DatePicker
                      inputFormat="yyyy-MM"
                      views={["year", "month"]}
                      label="Choisir un mois"
                      minDate={new Date("2021-01-01")}
                      maxDate={new Date()}
                      value={monthlyDate}
                      onChange={() => console.log()}
                      onMonthChange={(newDate) => {
                        monthlyTransactions(newDate);
                      }}
                      // onClose={monthlyTransactions}
                      renderInput={(params) => (
                        <TextField {...params} helperText={null} />
                      )}
                    />
                  </Stack>
                </LocalizationProvider>
              </Box>
              <Table
                sx={{
                  mt: 5,
                  boxShadow: 2,
                  borderRadius: "10px",
                  bgcolor: "#fff",
                }}
                aria-label="simple table"
              >
                {/* Component TblHead imported from useTable */}
                <TblHead />

                {/* 2 different table body to adjust to the screen size */}

                <TableBody className={classes.tableBigScreen}>
                  {listTransactions}
                </TableBody>

                <TableBody className={classes.tableSmallScreen}>
                  {listTransactions2}
                </TableBody>
              </Table>
              <TblPagination />
            </Box>

            {/* Modal to confirm cancellation of transaction */}

            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: "500px",
                  bgcolor: "#fff",
                  p: 3,
                  borderRadius: 5,
                }}
              >
                <Typography variant="h6" className={classes.typo}>
                  Etes-vous sûr de vouloir annuler la transaction ?
                </Typography>
                <Typography variant="subtitle1" mt="5px">
                  Pour confirmer l'annulation veuillez saisir votre mot de passe
                  :
                </Typography>

                <TextField
                  id="outlined-pass"
                  className={classes.field}
                  color="secondary"
                  label="Mot de passe"
                  type={showPass ? "text" : "password"}
                  margin="normal"
                  onChange={(e) => setPassword(e.target.value)}
                  onKeyDown={handleKeyDown}
                  value={password}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment>
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowPassword}
                        >
                          {showPass ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />

                <Box
                  mt={2}
                  sx={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Button
                    variant="contained"
                    size="large"
                    onClick={() => sendApiCancel()}
                    sx={{ width: "200px" }}
                  >
                    Confirmer
                  </Button>
                  <Button
                    variant="contained"
                    color="error"
                    size="large"
                    onClick={() => handleClose()}
                    sx={{ width: "200px" }}
                  >
                    Retour
                  </Button>
                </Box>
              </Box>
            </Modal>

            {/* Modal to show progress/wait */}

            <Modal open={openWait}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: 400,
                  bgcolor: "#fff",
                  p: 4,
                  borderRadius: 5,
                }}
              >
                <LinearProgress />
              </Box>
            </Modal>

            {/* Modal to show that the transaction was cancelled with success */}

            <Modal open={openSuccess}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: 400,
                  bgcolor: "#fff",
                  p: 4,
                  borderRadius: 5,
                }}
              >
                <IconButton color="primary" className={classes.icon}>
                  <MdCheckCircle className={classes.icon} />
                </IconButton>
                <Typography mb={2}>Transaction annulée avec succès</Typography>

                <Button
                  color="error"
                  variant="contained"
                  onClick={() => setOpenSuccess(false)}
                >
                  Fermer
                </Button>
              </Box>
            </Modal>

            {/* Modal to show there was an error */}

            <Modal open={openFailed}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  flexDirection: "column",
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: 400,
                  bgcolor: "#fff",
                  p: 4,
                  borderRadius: 5,
                }}
              >
                <IconButton color="error" className={classes.icon}>
                  <MdError className={classes.icon} />
                </IconButton>
                <Typography mb={2}>{failMessage}</Typography>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={() => setOpenFailed(false)}
                >
                  Fermer
                </Button>
              </Box>
            </Modal>
          </Box>
        )}
      </Box>
    </Box>
  );
}

function mapDispatchToProps(dispatch) {
  return {
    onSetToken: function (token) {
      dispatch({ type: "setToken", token: token });
    },
  };
}

function mapStateToProps(state) {
  return { token: state.token };
}

export default connect(mapStateToProps, mapDispatchToProps)(Transactions);
